"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _NKGUWTUCcjs = require('../__chunks/NKGUWTUC.cjs');


var _OTCKJ4OKcjs = require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/O7FALLU5.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/hovercard/hovercard-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function HovercardProvider(props = {}) {
  const store = _NKGUWTUCcjs.useHovercardStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _OTCKJ4OKcjs.HovercardContextProvider, { value: store, children: props.children });
}


exports.HovercardProvider = HovercardProvider;
